exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".orderDetailsStatus[data-v-79a2acd4]{margin-left:95px;margin-right:80px}.icon-style[data-v-79a2acd4]{margin-left:5px;cursor:pointer;color:#f60}", ""]);

// exports
